// Color-click zoom popup (Horizon-tuned).
// On Color swatch click, fetches product.js and finds the variant matching the NEW selection,
// then opens a modal with that variant's image (or first product media if variant has no image).
(function () {
  const productCache = new Map();

  function makeModal() {
    let m = document.getElementById('lsm-color-zoom');
    if (m) return m;
    m = document.createElement('div');
    m.id = 'lsm-color-zoom';
    m.innerHTML =
      '<div class="lsm-zoom__backdrop" data-close></div>' +
      '<div class="lsm-zoom__panel" role="dialog" aria-modal="true" aria-label="Color preview">' +
        '<button class="lsm-zoom__close" data-close aria-label="Close">×</button>' +
        '<img class="lsm-zoom__img" alt="">' +
        '<div class="lsm-zoom__caption"></div>' +
      '</div>';
    document.body.appendChild(m);
    m.addEventListener('click', function (e) { if (e.target.matches('[data-close]')) close(); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
    return m;
  }
  function open(src, caption) {
    const m = makeModal();
    m.querySelector('.lsm-zoom__img').src = src;
    m.querySelector('.lsm-zoom__caption').textContent = caption || '';
    m.classList.add('is-open');
    document.documentElement.style.overflow = 'hidden';
  }
  function close() {
    const m = document.getElementById('lsm-color-zoom');
    if (!m) return;
    m.classList.remove('is-open');
    document.documentElement.style.overflow = '';
  }

  function getProductHandle() {
    // Try canonical link, then URL path
    const canonical = document.querySelector('link[rel=canonical]');
    if (canonical) {
      const m = canonical.href.match(/\/products\/([^?/#]+)/);
      if (m) return m[1];
    }
    const m = location.pathname.match(/\/products\/([^?/#]+)/);
    return m ? m[1] : null;
  }
  async function fetchProduct(handle) {
    if (productCache.has(handle)) return productCache.get(handle);
    const p = fetch('/products/' + handle + '.js', { credentials: 'same-origin' })
      .then(r => r.ok ? r.json() : null)
      .catch(() => null);
    productCache.set(handle, p);
    return p;
  }

  function getCurrentSelection(clickedInput, newValue) {
    // Read all checked radios in the variant picker, but OVERRIDE the clicked option with new value.
    const inputs = clickedInput.closest('form, variant-picker, .product-information, body')
      .querySelectorAll('input[type=radio]:checked');
    const sel = {};
    inputs.forEach(i => {
      const name = (i.name || '').replace(/[-_].*$/, '').toLowerCase();
      // Extract option name from aria-label of parent fieldset OR the input's data attr
      // Fallback: use the input name token between "-" and "-_"
      sel[name] = i.value;
    });
    // Better: scan all option groups
    const norm = s => s.trim().replace(/\s+/g, ' ');
    const all = {};
    document.querySelectorAll('input[type=radio]:checked').forEach(i => {
      const n = i.name || '';
      const m = n.match(/^([^-]+)-/);
      if (m) all[norm(m[1])] = i.value;
    });
    const clickedName = (clickedInput.name || '').match(/^([^-]+)-/);
    if (clickedName) all[norm(clickedName[1])] = newValue;
    return all;
  }

  function findVariantImage(product, selection) {
    if (!product || !product.variants) return null;
    const norm = s => String(s).trim().toLowerCase().replace(/\s+/g, ' ');
    // product.options is array of {name, position, values}
    const optionNames = (product.options || []).map(o => typeof o === 'string' ? o : o.name);
    for (const v of product.variants) {
      const opts = {};
      (v.options || []).forEach((val, idx) => {
        const optName = optionNames[idx];
        if (optName) opts[optName] = val;
      });
      let match = true;
      for (const [k, v2] of Object.entries(selection)) {
        const found = Object.keys(opts).find(o => norm(o) === norm(k));
        if (!found || opts[found] !== v2) { match = false; break; }
      }
      if (match) {
        // Only return the variant's OWN featured_image. If unlinked → null → popup skipped.
        // (Linker is responsible for setting variant.image, including "All Colors" fallback.)
        return v.featured_image ? v.featured_image.src : null;
      }
    }
    return null;
  }
  function upgradeWidth(src) {
    if (!src) return src;
    // Make src absolute
    if (src.startsWith('//')) src = 'https:' + src;
    // Strip existing size suffix like _500x500
    src = src.replace(/_(small|compact|medium|large|grande|original|\d+x\d*)(?=\.[a-z]+)/i, '');
    // Add width param
    src = src.replace(/[?&]width=\d+/, '');
    src += (src.includes('?') ? '&' : '?') + 'width=1600';
    return src;
  }

  // Options that trigger popup (visual options affecting appearance). Size is skipped.
  // Matches any option whose name starts with a visual-attribute keyword.
  const TRIGGER_OPTIONS = /^(Color|Belt\s*buckle|Buckle|Finish|Material|Hardware|Premium\s*Snaps|Snaps|Chicago\s*Screws|Floral\s*Chicago\s*Screws|Rivets)/i;

  function attach() {
    document.querySelectorAll('label.variant-option__button-label input[type=radio]').forEach(function (input) {
      if (input.__lsmAttached) return;
      input.__lsmAttached = true;
      const label = input.closest('label');
      label.addEventListener('click', async function () {
        const inputName = input.name || '';
        if (!TRIGGER_OPTIONS.test(inputName)) return;
        const optionMatch = inputName.match(/^([^-]+)-/);
        const optionLabel = optionMatch ? optionMatch[1] : 'Option';
        const newValue = input.value;
        const handle = getProductHandle();
        if (!handle) return;
        const product = await fetchProduct(handle);
        if (!product) return;
        // Build full selection with the clicked option overridden
        const selection = getCurrentSelection(input, newValue);
        let src = findVariantImage(product, selection);
        // Fallback 1: same Color, drop other constraints
        if (!src && selection.Color) src = findVariantImage(product, { Color: selection.Color });
        // Fallback 2: just the clicked option
        if (!src) src = findVariantImage(product, { [optionLabel]: newValue });
        if (!src) return;
        // Caption: combine non-size selected options, e.g. "Black · Gold"
        const captionParts = [];
        Object.entries(selection).forEach(([k, v]) => { if (!/size/i.test(k)) captionParts.push(v); });
        const caption = captionParts.length > 1 ? captionParts.join(' · ') : newValue;
        open(upgradeWidth(src), caption);
      });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', attach);
  else attach();
  document.addEventListener('shopify:section:load', attach);
  new MutationObserver(attach).observe(document.body, { childList: true, subtree: true });
})();
